function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "talks thin"
}, React.createElement("g", {
  id: "hexagon"
}, React.createElement("path", {
  id: "Vector",
  d: "M194.248 56.2L97.6021 0.400009L0.95401 56.2L0.95401 167.8L97.6021 223.6L194.25 167.8V56.2H194.248ZM3.43401 166.369L3.43401 57.631L97.6021 3.2644L191.768 57.631V166.369L97.6021 220.736L3.43401 166.369Z",
  fill: "currentColor"
})), React.createElement("g", {
  id: "talks"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("g", {
  id: "Group_2"
}, React.createElement("path", {
  id: "Vector_2",
  d: "M69.6086 82.5582C67.4519 80.3291 64.4801 79.0744 61.3785 79.0833H60.7881C57.6896 79.0771 54.7221 80.3315 52.5676 82.5582C50.5407 84.6421 49.4645 87.4704 49.5929 90.3743L49.8172 95.534C50.1569 101.438 55.0973 106.021 61.0105 105.917H61.1561C67.0693 106.021 72.0097 101.438 72.3494 95.534L72.5833 90.3743C72.7117 87.4704 71.6355 84.6421 69.6086 82.5582ZM68.5199 95.3749C68.2602 99.2233 65.012 102.182 61.1561 102.083H61.0105C57.1546 102.182 53.9064 99.2233 53.6466 95.3749L53.5796 93.809C57.2332 93.6463 60.7414 92.3298 63.5999 90.0485C64.7786 91.7917 66.558 93.0397 68.5985 93.5541L68.5199 95.3749ZM66.1164 86.3149C66.0098 85.4974 65.3922 84.8397 64.5831 84.6819C63.7769 84.5151 62.9552 84.8865 62.5476 85.6019C62.5227 85.6421 60.1441 89.4045 53.432 89.9795C53.4154 88.2037 54.0985 86.4929 55.3333 85.2166C56.7643 83.742 58.7332 82.9118 60.7881 82.9166H61.3785C63.4334 82.9118 65.4023 83.742 66.8333 85.2166C67.9514 86.3817 68.6151 87.909 68.7039 89.5214C67.3776 88.9287 66.4154 87.7365 66.1164 86.3149Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_3"
}, React.createElement("g", {
  id: "Group_4"
}, React.createElement("path", {
  id: "Vector_3",
  d: "M144.358 128.558C142.202 126.329 139.23 125.074 136.128 125.083H135.538C132.439 125.077 129.472 126.331 127.317 128.558C125.291 130.642 124.214 133.47 124.343 136.374L124.567 141.534C124.907 147.438 129.847 152.021 135.76 151.916H135.906C141.819 152.021 146.76 147.438 147.099 141.534L147.333 136.374C147.462 133.47 146.385 130.642 144.358 128.558ZM143.5 136.219L143.27 141.375C143.01 145.223 139.762 148.182 135.906 148.083H135.76C131.904 148.182 128.656 145.223 128.396 141.375L128.166 136.209C128.092 134.352 128.786 132.547 130.083 131.217C131.514 129.742 133.483 128.912 135.538 128.917H136.128C138.183 128.912 140.152 129.742 141.583 131.217C142.883 132.549 143.576 134.359 143.5 136.219Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_5"
}, React.createElement("g", {
  id: "Group_6"
}, React.createElement("path", {
  id: "Vector_4",
  d: "M99.2091 85.874C97.1525 83.8848 93.8889 83.8848 91.8323 85.874L70.4347 107.272C70.0748 107.631 69.5866 107.834 69.0777 107.833H49.5833C44.2933 107.839 40.0062 112.127 40 117.417V144.25C40 147.425 42.5743 150 45.75 150C46.4029 150 47.0509 149.889 47.6667 149.672V151.916C47.6667 152.975 48.5248 153.833 49.5833 153.833H72.5833C73.6417 153.833 74.4999 152.975 74.4999 151.916V120.84C74.4997 120.355 74.6832 119.888 75.0136 119.533L99.3341 93.3758C101.371 91.2699 101.315 87.9112 99.2091 85.874ZM96.5969 90.6956C96.5899 90.7023 96.583 90.709 96.576 90.7155L72.1999 116.924C71.2128 117.989 70.6649 119.388 70.6666 120.84V150H51.5V121.25C51.5 120.191 50.6418 119.333 49.5833 119.333C48.5248 119.333 47.6667 120.191 47.6667 121.25V144.25C47.6667 145.308 46.8085 146.166 45.75 146.166C44.6915 146.166 43.8333 145.308 43.8333 144.25V117.417C43.8333 114.241 46.4076 111.667 49.5833 111.667H69.0777C70.6041 111.671 72.0689 111.065 73.1448 109.982L94.5425 88.5842C95.1259 88.0307 96.0406 88.0307 96.624 88.5842C97.1994 89.1748 97.1875 90.1201 96.5969 90.6956Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_7"
}, React.createElement("g", {
  id: "Group_8"
}, React.createElement("path", {
  id: "Vector_5",
  d: "M61.0833 113.583C60.0248 113.583 59.1666 114.441 59.1666 115.5V138.5C59.1666 139.558 60.0248 140.416 61.0833 140.416C62.1418 140.416 63 139.558 63 138.5V115.5C63 114.441 62.1418 113.583 61.0833 113.583Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_9"
}, React.createElement("g", {
  id: "Group_10"
}, React.createElement("path", {
  id: "Vector_6",
  d: "M102.182 128.558C100.028 126.331 97.0602 125.077 93.9617 125.083H93.3714C90.2729 125.077 87.3054 126.331 85.1508 128.558C83.1239 130.642 82.0475 133.47 82.1762 136.374L82.4004 141.534C82.7401 147.438 87.6806 152.021 93.5937 151.916H93.7394C99.6525 152.021 104.593 147.438 104.933 141.534L105.157 136.374C105.286 133.47 104.209 130.642 102.182 128.558ZM101.333 136.219L101.103 141.375C100.843 145.223 97.5952 148.182 93.7394 148.083H93.5937C89.7379 148.182 86.4896 145.223 86.2299 141.375L85.9999 136.209C85.9259 134.352 86.619 132.547 87.9166 131.217C89.3476 129.742 91.3165 128.912 93.3714 128.917H93.9617C96.0166 128.912 97.9855 129.742 99.4165 131.217C100.717 132.549 101.41 134.359 101.333 136.219Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_11"
}, React.createElement("g", {
  id: "Group_12"
}, React.createElement("path", {
  id: "Vector_7",
  d: "M103.57 153.833H83.7632C78.6495 153.838 74.5052 157.983 74.4999 163.096V171.083C74.4999 172.142 75.3581 173 76.4166 173C77.4751 173 78.3332 172.142 78.3332 171.083V163.096C78.3364 160.099 80.7657 157.67 83.7632 157.666H103.57C106.568 157.67 108.997 160.099 109 163.096V171.083C109 172.142 109.858 173 110.917 173C111.975 173 112.833 172.142 112.833 171.083V163.096C112.828 157.983 108.684 153.838 103.57 153.833Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_13"
}, React.createElement("g", {
  id: "Group_14"
}, React.createElement("path", {
  id: "Vector_8",
  d: "M145.737 153.833H125.93C120.816 153.838 116.672 157.983 116.667 163.096V171.083C116.667 172.142 117.525 173 118.583 173C119.642 173 120.5 172.142 120.5 171.083V163.096C120.503 160.099 122.932 157.67 125.93 157.666H145.737C148.734 157.67 151.163 160.099 151.166 163.096V171.083C151.166 172.142 152.025 173 153.083 173C154.142 173 155 172.142 155 171.083V163.096C154.994 157.983 150.85 153.838 145.737 153.833Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_15"
}, React.createElement("g", {
  id: "Group_16"
}, React.createElement("path", {
  id: "Vector_9",
  d: "M149.346 58H82.0707C78.9233 58.0307 76.3943 60.6026 76.4166 63.75V92.4999C76.4166 93.5584 77.2748 94.4166 78.3333 94.4166C79.3917 94.4166 80.2499 93.5584 80.2499 92.4999V69.5H151.166V115.5C151.191 116.531 150.377 117.388 149.346 117.417H83.9395C82.881 117.417 82.0228 118.275 82.0228 119.333C82.0228 120.392 82.881 121.25 83.9395 121.25H149.346C152.493 121.219 155.022 118.647 155 115.5V63.75C155.022 60.6026 152.493 58.0307 149.346 58ZM151.166 65.6666H80.2499V63.75C80.2252 62.7186 81.0393 61.8616 82.0707 61.8333H149.346C150.377 61.8616 151.191 62.7186 151.166 63.75V65.6666Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_17"
}, React.createElement("g", {
  id: "Group_18"
}, React.createElement("path", {
  id: "Vector_10",
  d: "M145.416 82.4374C144.358 82.4374 143.5 83.2956 143.5 84.3541V111.667C143.5 112.725 144.358 113.583 145.416 113.583C146.475 113.583 147.333 112.725 147.333 111.667V84.3541C147.333 83.2956 146.475 82.4374 145.416 82.4374Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_19"
}, React.createElement("g", {
  id: "Group_20"
}, React.createElement("path", {
  id: "Vector_11",
  d: "M137.75 94.4166C136.691 94.4166 135.833 95.2748 135.833 96.3333V111.667C135.833 112.725 136.691 113.583 137.75 113.583C138.808 113.583 139.666 112.725 139.666 111.667V96.3333C139.666 95.2748 138.808 94.4166 137.75 94.4166Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_21"
}, React.createElement("g", {
  id: "Group_22"
}, React.createElement("path", {
  id: "Vector_12",
  d: "M130.083 90.5833C129.025 90.5833 128.166 91.4415 128.166 92.4999V111.667C128.166 112.725 129.025 113.583 130.083 113.583C131.142 113.583 132 112.725 132 111.667V92.4999C132 91.4415 131.142 90.5833 130.083 90.5833Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_23"
}, React.createElement("g", {
  id: "Group_24"
}, React.createElement("path", {
  id: "Vector_13",
  d: "M122.416 102.083C121.358 102.083 120.5 102.941 120.5 104V111.667C120.5 112.725 121.358 113.583 122.416 113.583C123.475 113.583 124.333 112.725 124.333 111.667V104C124.333 102.941 123.475 102.083 122.416 102.083Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_25"
}, React.createElement("g", {
  id: "Group_26"
}, React.createElement("path", {
  id: "Vector_14",
  d: "M146.48 73.6553C145.599 73.0678 144.409 73.3055 143.822 74.1862L137.278 83.9995L131.233 79.4666C130.39 78.8272 129.187 78.993 128.548 79.8365C128.475 79.9326 128.412 80.0351 128.358 80.1432L120.895 95.0721L113.6 100.55C112.753 101.185 112.581 102.386 113.217 103.233C113.852 104.08 115.053 104.252 115.9 103.617L123.566 97.8666C123.808 97.6888 124.005 97.4571 124.141 97.19L130.779 83.9114L136.6 88.2833C137.446 88.9184 138.648 88.7471 139.283 87.9002C139.304 87.8719 139.325 87.8429 139.344 87.8137L147.011 76.3137C147.599 75.433 147.361 74.2428 146.48 73.6553Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_27"
}, React.createElement("g", {
  id: "Group_28"
}, React.createElement("path", {
  id: "Vector_15",
  d: "M109 73.3333H85.9999C84.9414 73.3333 84.0832 74.1915 84.0832 75.25C84.0832 76.3084 84.9414 77.1666 85.9999 77.1666H109C110.058 77.1666 110.917 76.3084 110.917 75.25C110.917 74.1915 110.058 73.3333 109 73.3333Z",
  fill: "currentColor"
}))), React.createElement("g", {
  id: "Group_29"
}, React.createElement("g", {
  id: "Group_30"
}, React.createElement("path", {
  id: "Vector_16",
  d: "M120.5 73.3333H116.667C115.608 73.3333 114.75 74.1915 114.75 75.25C114.75 76.3084 115.608 77.1666 116.667 77.1666H120.5C121.558 77.1666 122.416 76.3084 122.416 75.25C122.416 74.1915 121.558 73.3333 120.5 73.3333Z",
  fill: "currentColor"
})))));

var SvgTalksthin = function SvgTalksthin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 195,
    height: 224,
    viewBox: "0 0 195 224",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTalksthin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/talks thin.98ac2265.svg";
export { ForwardRef as ReactComponent };